export default __webpack_public_path__ + "static/media/narthex_map_image.9e217fc1.png";